import { api } from 'api'
import { createAsyncThunk } from 'modules/store'
import { normalizeApiUrl } from 'packages/helper'
import { downloadBlob } from 'utils/downloadBlob'

export const getAllCfrLogs = createAsyncThunk('cfrLogs/getAllCfrLogs', async (_, { rejectWithValue }) =>
  api.cfrLogs.getAll().catch((error) => rejectWithValue(error.message)),
)

export const getCfrLogFile = createAsyncThunk('cfrLogs/getCfrLogFile', async (filename: string, { rejectWithValue }) =>
  api.cfrLogs
    .getLink(filename)
    .then((data) => api.cfrLogs.download(normalizeApiUrl(data.link)))
    .then((data) => downloadBlob(data, filename))
    .catch((error) => rejectWithValue(error.message)),
)
